import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../../config/apila";
import { APIMS } from "../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import Swal from "sweetalert2";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import swal from "sweetalert";

export default function ListPrilaku() {
  document.title = "List Perilaku";

  const [getData, setGetData] = useState([]);
  const ascending = 0;

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level");

  // Responsive
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  // Search frontend
  const [searchKeyword, setSearchKeyword] = useState("");

  // Pagination frontend
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const firstLoadDone = useRef(false);

  const [loading, setLoading] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // UI state
  const [isFetching, setIsFetching] = useState(false);

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: ""
  });

  

  // modal update
  const [id, setId] = useState();
   const [dataUpdate, setDataUpdate] = useState();

  // modal add
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storageLevel = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
    } else {
      const foundPermission = storageItems.find(
        (item) => item.menu?.url === location.pathname
      );

      if (!foundPermission) {
        navigate("/dashboard");
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete,
        });
      }
    }
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // )
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        )
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
        setLoading(false);
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id

  // =========================
  // Fetch table data
  // =========================
  // const GetResponseData = useCallback(async () => {
  //   setSearchKeyword("");
  //   setIsFetching(true);

  //   try {
  //     const response = await APILA.get(
  //       `/api/config-anomalys?page=1&limit=1000&ascending=${ascending}&search=`,
  //       fetchParams
  //     );

  //     if (response?.status === 200) {
  //       setGetData(response?.data?.data || []);
  //     }
  //   } catch (error) {
  //     ToastError.fire({
  //       icon: "error",
  //       title: error.response?.data?.message || "Gagal memuat data",
  //     });
  //   } finally {
  //     setIsFetching(false);
  //   }
  // }, [ascending, fetchParams]);

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id 
    ) return;

    const params = {

      ysb_semester_id: form2?.ysb_semester_id,
      page: 1,
      limit: 100000,
      ascending: 0,
    };

    try {
      const response = await APILA.get(
        "/api/config-anomalys",
        {
          params,
          ...fetchParams,
        }
      );

      if (response?.status === 200) {
        setGetData(response.data.data || []);
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [form2, fetchParams, storageLevel]);

  // useEffect(() => {
  //   GetResponseData();
  // }, [GetResponseData]);


   // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
    useEffect(() => {
      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id 
      ) return;
    
      firstLoadDone.current = true;
    
      (async () => {
        setIsFetching(true);
        await GetResponseData(); // ✅ HANYA SEKALI
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    
    }, [
      form2.ysb_semester_id
  ]);


  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

    /* ================= DELETE ================= */
    const deleteById = (row) => {
      Swal.fire({
        title: "Apakah Kamu Yakin?",
        text: "Semua data terkait perilaku ini akan dihapus dan tidak bisa dikembalikan.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus",
        cancelButtonText: "Batal",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),

        preConfirm: async () => {
          try {
            const payload = {
              ysb_semester_id: form2?.ysb_semester_id,
              ysb_sub_element_id: row?.ysb_sub_element_id,
              user_id: localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "")
            };

            const response = await APILA.delete(
              `/api/config-anomalys/delete-all`,
              {
                ...fetchParams,
                data: payload,
              }
            );

            if (response?.data?.error) {
              throw new Error(response?.data?.message || "Gagal menghapus data");
            }

            return response;
          } catch (error) {
            Swal.showValidationMessage(
              error?.response?.data?.message ||
                error?.message ||
                "Gagal menghapus data"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          ToastSuccess.fire({
            icon: "success",
            title: "Data berhasil dihapus",
          });

          GetResponseData();
        }
      });
    };


  const viewModalAdd = () => {
    setModalAdd(true);
  };

   const viewModalUpdate = (id, row) => {
    setModalUpdate(true)
    setId(id)
    setDataUpdate(row)
  }

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  // =========================
  // FILTER SEARCH FRONTEND
  // =========================
  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = !q
      ? getData || []
      : (getData || []).filter((item) => {
          const kodePrilaku = (item?.branch_initial || "").toString().toLowerCase();
          const namaPrilaku = (item?.branch_name || "").toString().toLowerCase();
          const branchCode = (item?.branch_code || "").toString().toLowerCase();

          return (
            kodePrilaku.includes(q) ||
            namaPrilaku.includes(q) ||
            branchCode.includes(q)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.branch_name || "").toString().trim(),
        (b?.branch_name || "").toString().trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);

  // =========================
  // FRONTEND PAGINATION
  // =========================
  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }
    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter((v, idx, arr) => arr.indexOf(v) === idx);
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const p = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
    setTablePage(p);
  };

  return (
    <div className="body">
      {/* {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )} */}

      <ModalAdd
        GetResponseData={GetResponseData}
        usedIndikatorData={getData}
        selectedSemesterId={form2.ysb_semester_id}
        show={modalAdd}
        onHide={() => setModalAdd(false)}
      />

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          dataUpdate={dataUpdate}
          id={id}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      {/* <div className="page-header-card">
        <div className="page-header-top d-flex">
          {isTabletOrMobile ? (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faList} />
                </span>
                <h4 className="page-title-text"> List Prilaku</h4>
              </div>

              <div className="ml-auto">
                <button onClick={viewModalAdd} className="btn btn-create">
                  <FontAwesomeIcon icon={faPlus} />
                  Prilaku
                </button>
              </div>



             
            </>
          ) : (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faList} />
                </span>
                <h4 className="page-title-text"> List Prilaku</h4>
              </div>

              <div className="ml-auto">
                <button
                  onClick={viewModalAdd}
                  className="btn btn-create mr-2"
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} /> Tambah Prilaku
                </button>
              </div>

             
            
            </>
          )}
        </div>
      </div> */}

          <div className="page-header-card">
               {isTabletOrMobile ? (
                <>
                  <div className="page-header-top d-flex">
                    <div className="page-title-wrap">
                      <span className="page-title-icon">
                        <FontAwesomeIcon icon={faList} />
                        </span>
                      <h4 className="page-title-text">   List Perilaku  </h4>
                    </div>
                  </div>
                  <div className="ml-auto">
                      <button
                        onClick={() => setModalAdd(true)}
                        className="btn btn-create"
                        style={{
                          borderRadius: 12,
                          padding: "8px 14px",
                          boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                        }}
                      >
                       <FontAwesomeIcon icon={faPlus} /> List Perilaku
                      </button>
                      
                  </div>
      
                  
      
                   <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
                    <ol className="custom-breadcrumb">
                      <li className="custom-breadcrumb-item">
                        <Link to="/angket-employees">Penilaian Karyawan</Link>
                      </li>
                      <li className="custom-breadcrumb-separator">/</li>
                      <li
                        className="custom-breadcrumb-item active"
                        aria-current="page"
                      >
                         List Perilaku 
                      </li>
                    </ol>
                  </nav>
                </>
                ) : (
                <>
                  <div className="page-header-top d-flex">
                    <div className="page-title-wrap">
                      <span className="page-title-icon">
                        <FontAwesomeIcon icon={faList} />
                      </span>
                      <h4 className="page-title-text">  List Perilaku </h4>
                    </div>
      
                    <div className="ml-auto">
                      <button
                        onClick={() => setModalAdd(true)}
                        className="btn btn-create"
                        style={{
                          borderRadius: 12,
                          padding: "8px 14px",
                          boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                        }}
                      >
                       <FontAwesomeIcon icon={faPlus} /> Tambah List Perilaku
                      </button>
                    </div>
                  </div>
      
      
      
                  <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
                    <ol className="custom-breadcrumb">
                      <li className="custom-breadcrumb-item">
                        <Link to="/angket-employees">Penilaian Karyawan</Link>
                      </li>
                      <li className="custom-breadcrumb-separator">/</li>
                      <li
                        className="custom-breadcrumb-item active"
                        aria-current="page"
                      >
                        List Perilaku
                      </li>
                    </ol>
                  </nav>
                </>
               )}
            </div>

          

      <div className="body-content">

        {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester})
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                           style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            background: "#fff",
                          }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>

                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                          }}
                        >
                          Cari
                        </button>

                      </div>
                    </div>
                )
              }
              </div>
              
            </>           
          )}

        {isFetching && (
          <div className="text-center" style={{ padding: "10px 0" }}>
            <span style={{ color: "#2e52aeff", fontWeight: "500" }}>
              <PulseLoader color={"#3f5bea"} size={12} />
            </span>
          </div>
        )}

        {/* {!isFetching && ( */}
         {hasSearched && !isFetching && (
          <>
            <div className="mt-1">
              <div className="at-search">
                <input
                  className="at-input"
                  placeholder="Cari Perilaku"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </div>
            </div>

            <Col xl="12" sm="12">
              <div className="mt-3">
                <div className="body-table">
                  <div>
                    <table
                      className="table dt-responsive nowrap w-100"
                      id="basic-datatable"
                    >
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Perilaku</th>
                          <th>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.length > 0 ? (
                          paginatedData.map((row, index) => (
                            <tr key={row?.id || index}>
                              <td style={{ lineHeight: "2" }}>
                                {(tablePage - 1) * rowsPerPage + (index + 1)}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                {row.description_anomaly}
                              </td>
                              <td style={{ lineHeight: "2" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    flexWrap: "nowrap",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <button
                                    className="button-edit button-table"
                                    onClick={() => viewModalUpdate(row?.id, row)}
                                  >
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </button>
                                  
                                  <button
                                    className="button-delete button-table"
                                    onClick={() => deleteById(row)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                  
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center" style={{ padding: "20px" }}>
                              Data tidak ditemukan
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {filteredData.length > 0 && (
                      <div className="at-pagination">
                        <div
                          className="d-flex"
                          style={{ gap: 8, alignItems: "center" }}
                        >
                          <span className="at-page-info">
                            Menampilkan <b>{Math.min((tablePage - 1) * rowsPerPage + 1, totalRows)}</b>-
                            <b>{Math.min(tablePage * rowsPerPage, totalRows)}</b> dari <b>{totalRows}</b> data
                          </span>

                          <select
                            className="at-page-size"
                            value={rowsPerPage}
                            onChange={(e) => {
                              const v = Number(e.target.value) || 10;
                              setRowsPerPage(v);
                              setTablePage(1);
                            }}
                          >
                            <option value={10}>10 / halaman</option>
                            <option value={25}>25 / halaman</option>
                            <option value={50}>50 / halaman</option>
                            <option value={100}>100 / halaman</option>
                          </select>
                        </div>

                        <div
                          className="d-flex"
                          style={{ gap: 8, alignItems: "center" }}
                        >
                          <button
                            className="at-page-btn"
                            onClick={() => goToPage(tablePage - 1)}
                            disabled={tablePage <= 1}
                          >
                            Prev
                          </button>

                          <div className="at-page-numbers">
                            {pageNumbers.map((p, idx) =>
                              p === "..." ? (
                                <span
                                  key={`dots-${idx}`}
                                  className="at-page-info"
                                  style={{ padding: "0 6px" }}
                                >
                                  ...
                                </span>
                              ) : (
                                <button
                                  key={`page-${p}`}
                                  className={`at-page-number ${
                                    p === tablePage ? "active" : ""
                                  }`}
                                  onClick={() => goToPage(p)}
                                >
                                  {p}
                                </button>
                              )
                            )}
                          </div>

                          <button
                            className="at-page-btn"
                            onClick={() => goToPage(tablePage + 1)}
                            disabled={tablePage >= totalPages}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </>
        )}
      </div>
    </div>
  );
}